import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import {
  fetchObalMaterialuNrSrZaBezchybnostInitData,
} from '../../../../client/pracovnyKrok/sprievodnyDokument/obalMaterialuInitDataClient';
import {
  ObalMaterialuNrSrBezchybnostFormData,
} from '../../../../model/pracovnyKrok/ObalMaterialuNrSrBezchybnostFormData';

interface ReturnType {
  obalInitData: ObalMaterialuNrSrBezchybnostFormData;
  initDataStatus: ClientStatus;
}

export default (type: string, year: number, index: number): ReturnType => {
  const {
    data: obalInitData,
    status: initDataStatus,
  } = useClientFetch(fetchObalMaterialuNrSrZaBezchybnostInitData, [type, year, index], []);
  return {
    obalInitData,
    initDataStatus,
  };
};
